import { render, staticRenderFns } from "./DetailPlante.vue?vue&type=template&id=679616f0"
import script from "./DetailPlante.vue?vue&type=script&lang=js"
export * from "./DetailPlante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports